import { Action } from './action';

export class AmendBasket extends Action {
    constructor(public giftId: string, public quantity: number) {
        super();
    }
}

export class RemoveUnavailableGifts extends Action {}
